import logo from "../../../assets/images/rockinyangon/IMG_3860.png";
import { AiOutlineShoppingCart } from "react-icons/ai";
const Header = () => {
  return (
    <header class="text-white w-full  bg-[#131313] fixed flex flex-col overflow-hidden px-10 py-4 lg:flex-row lg:items-center">
      <a
        href="#"
        class="lg:hidden flex items-center whitespace-nowrap text-2xl font-black"
      >
        <img
            src={logo}
            className="w-14 hover:scale-110 transition-all cursor-pointer"
            alt=""
          />
        
      </a>
      <input type="checkbox" class="peer hidden" id="navbar-open" />
      <label
        class="absolute top-5 right-5 cursor-pointer lg:hidden"
        for="navbar-open"
      >
        <svg
          class="h-7 w-7"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </label>
      <nav
        aria-label="Header Navigation"
        class="peer-checked:pt-8 peer-checked:max-h-60 flex max-h-0 w-full flex-col items-center overflow-hidden transition-all lg:ml-24 lg:max-h-full lg:flex-row"
      >
        <ul class="flex w-full flex-col items-center space-y-2 lg:flex-row lg:justify-center lg:space-y-0">
          <img
            src={logo}
            className="w-20 hidden lg:block hover:scale-110 transition-all cursor-pointer"
            alt=""
          />
          {/* <li class="lg:mr-12">
            <a
              class="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
              href="#"
            >
              Components
            </a>
          </li>
          <li class="lg:mr-12">
            <a
              class="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
              href="#"
            >
              Pricing
            </a>
          </li>
          <li class="lg:mr-12">
            <a
              class="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
              href="#"
            >
              Contact
            </a>
          </li>
          <li class="lg:mr-12">
            <a
              class="rounded text-gray-700 transition focus:outline-none focus:ring-1 focus:ring-blue-700 focus:ring-offset-2"
              href="#"
            >
              FAQ
            </a>
          </li> */}
        </ul>
        <hr class="mt-4 w-full lg:hidden" />
        <div class="my-4 flex items-center space-x-6 space-y-2 lg:my-0 lg:ml-auto lg:space-x-8 lg:space-y-0">
          <a className="bg-black/20 p-2 rounded-full cursor-pointer" href="">
            <AiOutlineShoppingCart
              className="hover:scale-110 scale-100 transition-all"
              size={24}
            />
          </a>
          {/* <a
            href="#"
            title=""
            class="whitespace-nowrap rounded-xl bg-blue-700 px-5 py-3 font-medium text-white transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-700 focus:ring-offset-2 hover:bg-blue-600"
          >
            Get free trial
          </a> */}
        </div>
      </nav>
    </header>
  );
};

export default Header;
